"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertFirstToMergeField = exports.shouldConvertFirstToMergeField = exports.isDeepMerge = exports.hasPossibleSelectionType = exports.hasActualSelectionType = exports.doDefaultMerging = exports.handleCursorPosition = exports.isTypeIncluded = exports.isMergingAllowed = exports.wasNewItemSelected = exports.isItemNoLongerSelected = exports.didValueChange = exports.isNoLongerMerging = exports.getDataForFiltering = exports.findFailedValidation = exports.getHighlightedItem = exports.getResultsData = exports.getSelected = exports.convertToMergeField = exports.updateInputCursorPosition = exports.flattenArrays = exports.replaceWordAt = exports.getWordAt = exports.findLastDiffPosition = exports.findFirstDiffPosition = void 0;
var _fuzzysearch = _interopRequireDefault(require("fuzzysearch"));
var _mergeInputField = require("./mergeInputField.data");
var _mergeLookupField = require("./mergeLookupField.helper");
var _mergePromotionField = require("./mergePromotionField.helper");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var stringType = _mergeInputField.dataTypes.stringType,
  personDataType = _mergeInputField.dataTypes.personDataType,
  globalDataType = _mergeInputField.dataTypes.globalDataType,
  lookupType = _mergeInputField.dataTypes.lookupType,
  lookupFieldType = _mergeInputField.dataTypes.lookupFieldType;
var findLastDiffPosition = function findLastDiffPosition(string1, string2) {
  if (string1 === string2) {
    return -1;
  }
  var string1padded = string1.length >= string2.length ? string1 : string1.padStart(string2.length, ' ');
  var string2padded = string1.length <= string2.length ? string2 : string2.padStart(string1.length, ' '); // TODO: fix unallowed use of `while` loop, use recursion instead and unallowed use of `let`, use `const` instead

  var position = string1padded.length; // eslint-disable-line fp/no-let

  while (string1padded[position] === string2padded[position]) {
    // eslint-disable-line fp/no-loops
    position -= 1;
  }
  return position + 1;
}; // TODO: fix unallowed use of `while` loop, use recursion instead and unallowed use of `let`, use `const` instead

exports.findLastDiffPosition = findLastDiffPosition;
var findFirstDiffPosition = function findFirstDiffPosition(string1, string2) {
  var position = 0; // eslint-disable-line fp/no-let

  if (string1 === string2) {
    return -1;
  }
  while (string1[position] === string2[position]) {
    // eslint-disable-line fp/no-loops
    position += 1;
  }
  return position;
};
exports.findFirstDiffPosition = findFirstDiffPosition;
var getWordAt = function getWordAt(str, pos) {
  // TODO: Reduce redundancy between function declarations `getWordAt()` and `replaceWordAt()`
  var paddedStr = " ".concat(str, " ");
  var paddedPos = pos + 1 + (_mergeInputField.mergeTriggerSymbols.includes(str.charAt(pos)) ? 1 : 0);
  var leftChunk = paddedStr.slice(0, paddedPos);
  var rightChunk = paddedStr.slice(paddedPos);
  var left = leftChunk.search(/\S+$/);
  var right = rightChunk.search(/\s/);
  var leftPosition = left;
  var rightPosition = right + leftChunk.length;
  return paddedStr.slice(leftPosition, rightPosition).trim();
};
exports.getWordAt = getWordAt;
var replaceWordAt = function replaceWordAt(str, pos, replacement) {
  var paddedStr = " ".concat(str, " ");
  var paddedPos = pos + 1 + (_mergeInputField.mergeTriggerSymbols.includes(str.charAt(pos)) ? 1 : 0);
  var leftChunk = paddedStr.slice(0, paddedPos);
  var rightChunk = paddedStr.slice(paddedPos);
  var left = leftChunk.search(/\S+$/);
  var right = rightChunk.search(/\s/);
  var leftPosition = left;
  var rightPosition = right + leftChunk.length;
  return "".concat(paddedStr.slice(0, leftPosition)).concat(replacement).concat(paddedStr.slice(rightPosition)).trim();
};
exports.replaceWordAt = replaceWordAt;
var flattenArrays = function flattenArrays(arrays) {
  return arrays.reduce(function (left, right) {
    return left.concat(right);
  }, []);
};
exports.flattenArrays = flattenArrays;
var cleanUp = function cleanUp(text) {
  return text.replace(/[^A-Za-z0-9æåøÆÅØ:]/g, '').toLowerCase();
};
var fuzzySearch = function fuzzySearch(needle, haystack) {
  return (0, _fuzzysearch.default)(cleanUp(needle), cleanUp(haystack));
};
var searchFilter = function searchFilter(filter) {
  return function (_ref) {
    var title = _ref.title;
    return fuzzySearch(filter, title);
  };
};
var updateInputCursorPosition = function updateInputCursorPosition(input, position) {
  input.selectionStart = position; // eslint-disable-line no-param-reassign

  input.selectionEnd = position; // eslint-disable-line no-param-reassign

  input.blur();
  input.focus();
};
exports.updateInputCursorPosition = updateInputCursorPosition;
var convertToMergeField = function convertToMergeField(parameterName) {
  return "${param:".concat(parameterName, "}");
};
exports.convertToMergeField = convertToMergeField;
var getSelected = function getSelected(_ref2) {
  var selectedItem = _ref2.selectedItem;
  var isSomethingSelected = selectedItem !== null;
  return {
    isSomethingSelected: isSomethingSelected,
    isPromotionSelected: isSomethingSelected && (0, _mergePromotionField.isPromotionType)({
      type: selectedItem.sourceType
    }),
    isLookupSelected: isSomethingSelected && (0, _mergeLookupField.isLookupType)({
      type: selectedItem.sourceType
    }),
    isLookupFieldSelected: isSomethingSelected && (0, _mergeLookupField.isLookupFieldType)({
      type: selectedItem.sourceType
    })
  };
};
exports.getSelected = getSelected;
var isDeepMerge = function isDeepMerge(types) {
  return types.length === 1 && types.includes(stringType);
};
exports.isDeepMerge = isDeepMerge;
var filterPromotion = function filterPromotion(types) {
  return function (_ref3) {
    var sourceType = _ref3.sourceType;
    return !isDeepMerge(types) || !(0, _mergePromotionField.isPromotionType)({
      type: sourceType
    });
  };
};
var getPrimaryResults = function getPrimaryResults(_ref4) {
  var dataForFiltering = _ref4.dataForFiltering,
    value = _ref4.value,
    filter = _ref4.filter,
    isMerging = _ref4.isMerging,
    shouldShowResultsWhenBlank = _ref4.shouldShowResultsWhenBlank,
    numberOfItemsInDropdown = _ref4.numberOfItemsInDropdown,
    types = _ref4.types;
  return filter.length > 0 || isMerging || shouldShowResultsWhenBlank && value.length === 0 ? dataForFiltering.filter(searchFilter(filter)).filter(filterPromotion(types)).slice(0, numberOfItemsInDropdown) : [];
};
var getParentFieldsResults = function getParentFieldsResults(_ref5) {
  var selectedItem = _ref5.selectedItem,
    isParentSelected = _ref5.isParentSelected,
    filter = _ref5.filter,
    numberOfItemsInDropdown = _ref5.numberOfItemsInDropdown;
  return isParentSelected && (selectedItem.fields || []).map((0, _mergePromotionField.mapPropositionsToResults)(selectedItem)).filter(searchFilter(filter)).slice(0, numberOfItemsInDropdown);
};
var getResults = function getResults(_ref6) {
  var areResultsVisible = _ref6.areResultsVisible,
    propositionResults = _ref6.propositionResults,
    lookupResults = _ref6.lookupResults,
    dataForFiltering = _ref6.dataForFiltering,
    value = _ref6.value,
    filter = _ref6.filter,
    isMerging = _ref6.isMerging,
    shouldShowResultsWhenBlank = _ref6.shouldShowResultsWhenBlank,
    numberOfItemsInDropdown = _ref6.numberOfItemsInDropdown,
    types = _ref6.types;
  return areResultsVisible ? lookupResults || propositionResults || getPrimaryResults({
    dataForFiltering: dataForFiltering,
    value: value,
    filter: filter,
    isMerging: isMerging,
    shouldShowResultsWhenBlank: shouldShowResultsWhenBlank,
    numberOfItemsInDropdown: numberOfItemsInDropdown,
    types: types
  }) : [];
};
var getResultsVisibility = function getResultsVisibility(_ref7) {
  var isReadOnly = _ref7.isReadOnly,
    isSomethingSelected = _ref7.isSomethingSelected,
    isPromotionSelected = _ref7.isPromotionSelected,
    isLookupSelected = _ref7.isLookupSelected;
  return !isReadOnly && (!isSomethingSelected || isPromotionSelected || isLookupSelected);
};
var getResultsData = function getResultsData(_ref8) {
  var isReadOnly = _ref8.isReadOnly,
    isSomethingSelected = _ref8.isSomethingSelected,
    isPromotionSelected = _ref8.isPromotionSelected,
    isLookupSelected = _ref8.isLookupSelected,
    selectedItem = _ref8.selectedItem,
    dataForFiltering = _ref8.dataForFiltering,
    value = _ref8.value,
    filter = _ref8.filter,
    isMerging = _ref8.isMerging,
    shouldShowResultsWhenBlank = _ref8.shouldShowResultsWhenBlank,
    numberOfItemsInDropdown = _ref8.numberOfItemsInDropdown,
    types = _ref8.types;
  var propositionResults = getParentFieldsResults({
    selectedItem: selectedItem,
    isParentSelected: isPromotionSelected,
    filter: filter,
    numberOfItemsInDropdown: numberOfItemsInDropdown
  });
  var lookupResults = getParentFieldsResults({
    selectedItem: selectedItem,
    isParentSelected: isLookupSelected,
    filter: filter,
    numberOfItemsInDropdown: numberOfItemsInDropdown
  });
  var areResultsVisible = getResultsVisibility({
    isReadOnly: isReadOnly,
    isSomethingSelected: isSomethingSelected,
    isPromotionSelected: isPromotionSelected,
    isLookupSelected: isLookupSelected
  });
  var results = getResults({
    areResultsVisible: areResultsVisible,
    propositionResults: propositionResults,
    lookupResults: lookupResults,
    dataForFiltering: dataForFiltering,
    value: value,
    filter: filter,
    isMerging: isMerging,
    shouldShowResultsWhenBlank: shouldShowResultsWhenBlank,
    numberOfItemsInDropdown: numberOfItemsInDropdown,
    types: types
  });
  return {
    hasPromotionFieldResults: propositionResults.length > 0,
    hasLookupFieldResults: lookupResults.length > 0,
    areResultsVisible: areResultsVisible,
    results: results
  };
};
exports.getResultsData = getResultsData;
var routeSourceData = function routeSourceData(_ref9) {
  var isMerging = _ref9.isMerging,
    mergeSourceData = _ref9.mergeSourceData,
    selectionSourceData = _ref9.selectionSourceData;
  return isMerging ? mergeSourceData || [] : selectionSourceData || [];
};
var getDataForFiltering = function getDataForFiltering(_ref10) {
  var isMerging = _ref10.isMerging,
    mergeSourceData = _ref10.mergeSourceData,
    selectionSourceData = _ref10.selectionSourceData;
  return flattenArrays(routeSourceData({
    isMerging: isMerging,
    mergeSourceData: mergeSourceData,
    selectionSourceData: selectionSourceData
  }).map(function (_ref11) {
    var data = _ref11.data;
    return data;
  }));
};
exports.getDataForFiltering = getDataForFiltering;
var getHighlightedItem = function getHighlightedItem(_ref12) {
  var areResultsVisible = _ref12.areResultsVisible,
    results = _ref12.results,
    highlightedIndex = _ref12.highlightedIndex;
  return areResultsVisible && results[highlightedIndex];
};
exports.getHighlightedItem = getHighlightedItem;
var findFailedValidation = function findFailedValidation(_ref13) {
  var validation = _ref13.validation,
    value = _ref13.value;
  return validation && validation.find(function (condition) {
    return condition.criteria(value);
  });
};
exports.findFailedValidation = findFailedValidation;
var isNoLongerMerging = function isNoLongerMerging(_ref14) {
  var wasMerging = _ref14.wasMerging,
    isMerging = _ref14.isMerging;
  return wasMerging && !isMerging;
};
exports.isNoLongerMerging = isNoLongerMerging;
var didValueChange = function didValueChange(_ref15) {
  var prevValue = _ref15.prevValue,
    value = _ref15.value;
  return prevValue !== value;
};
exports.didValueChange = didValueChange;
var isItemNoLongerSelected = function isItemNoLongerSelected(_ref16) {
  var prevSelectedItem = _ref16.prevSelectedItem,
    selectedItem = _ref16.selectedItem;
  return prevSelectedItem && !selectedItem;
};
exports.isItemNoLongerSelected = isItemNoLongerSelected;
var wasNewItemSelected = function wasNewItemSelected(_ref17) {
  var prevSelectedItem = _ref17.prevSelectedItem,
    selectedItem = _ref17.selectedItem;
  return selectedItem !== null && (!prevSelectedItem || prevSelectedItem.id !== selectedItem.id);
};
exports.wasNewItemSelected = wasNewItemSelected;
var isMergingAllowed = function isMergingAllowed(_ref18) {
  var types = _ref18.types;
  return types.includes(stringType);
};
exports.isMergingAllowed = isMergingAllowed;
var isTypeIncluded = function isTypeIncluded(_ref19) {
  var type = _ref19.type,
    types = _ref19.types;
  return types.includes(type);
};
exports.isTypeIncluded = isTypeIncluded;
var handleCursorPosition = function handleCursorPosition(_ref20) {
  var inputRef = _ref20.inputRef,
    value = _ref20.value,
    types = _ref20.types,
    wasMerging = _ref20.wasMerging,
    isMerging = _ref20.isMerging,
    prevSelectedItem = _ref20.prevSelectedItem,
    selectedItem = _ref20.selectedItem,
    prevValue = _ref20.prevValue;
  if (isNoLongerMerging({
    wasMerging: wasMerging,
    isMerging: isMerging
  })) {
    var cursorPosition = findLastDiffPosition(prevValue, value);
    updateInputCursorPosition(inputRef, cursorPosition);
  } else if (isItemNoLongerSelected({
    prevSelectedItem: prevSelectedItem,
    selectedItem: selectedItem
  }) && isMergingAllowed({
    types: types
  }) && isTypeIncluded({
    type: prevSelectedItem.sourceType,
    types: [personDataType, globalDataType]
  })) {
    var newValue = convertToMergeField(prevValue);
    var _cursorPosition = findFirstDiffPosition(newValue, value) + 1;
    if (_cursorPosition === 1) {
      updateInputCursorPosition(inputRef, _cursorPosition);
    }
  } else if ((0, _mergeLookupField.isLookupMerging)({
    isMerging: isMerging,
    selectedItem: selectedItem,
    prevSelectedItem: prevSelectedItem
  })) {
    var _cursorPosition2 = findLastDiffPosition(prevValue, value);
    if (!prevSelectedItem) {
      updateInputCursorPosition(inputRef, _cursorPosition2 - 1);
    }
    if (prevSelectedItem && selectedItem.sourceType !== prevSelectedItem.sourceType) {
      updateInputCursorPosition(inputRef, _cursorPosition2 + 1);
    }
  }
};
exports.handleCursorPosition = handleCursorPosition;
var doDefaultMerging = function doDefaultMerging(_ref21) {
  var selectedItem = _ref21.selectedItem,
    inputValue = _ref21.inputValue,
    currentCursorPosition = _ref21.currentCursorPosition,
    onUpdateValue = _ref21.onUpdateValue,
    id = _ref21.id;
  if ([personDataType, globalDataType, lookupType, lookupFieldType].includes(selectedItem.sourceType) && [1, inputValue.length].includes(currentCursorPosition)) {
    if (lookupFieldType === selectedItem.sourceType) {
      if (inputValue.includes("".concat(selectedItem.parentTitle, ".").concat(selectedItem.title)) && !inputValue.includes('${param:')) {
        onUpdateValue(id, "${param:".concat(inputValue.trimRight(), "}"));
      }
    } else {
      var newValue = inputValue.replace(selectedItem.title, convertToMergeField(selectedItem.title));
      onUpdateValue(id, newValue);
    }
  }
};
exports.doDefaultMerging = doDefaultMerging;
var shouldConvertFirstToMergeField = function shouldConvertFirstToMergeField(_ref22) {
  var value = _ref22.value,
    highlightedItem = _ref22.highlightedItem,
    types = _ref22.types;
  return isDeepMerge(types) && !value.includes('${param') && highlightedItem.sourceType !== lookupType;
};
exports.shouldConvertFirstToMergeField = shouldConvertFirstToMergeField;
var convertFirstToMergeField = function convertFirstToMergeField(_ref23) {
  var value = _ref23.value,
    id = _ref23.id,
    selectedItem = _ref23.selectedItem,
    highlightedItem = _ref23.highlightedItem,
    cursorPosition = _ref23.cursorPosition,
    onUpdateValue = _ref23.onUpdateValue,
    onSelect = _ref23.onSelect,
    onUpdateFilter = _ref23.onUpdateFilter,
    onClearHighlight = _ref23.onClearHighlight,
    isPaginated = _ref23.isPaginated,
    onResetPaging = _ref23.onResetPaging;
  if (lookupFieldType === highlightedItem.sourceType) {
    if (value.includes("".concat(selectedItem.title, ".")) && !value.includes('${param:')) {
      onUpdateValue(id, "${param:".concat(selectedItem.title, ".").concat(highlightedItem.title, "}"));
      onSelect(id, highlightedItem);
    }
  } else {
    var newValue = replaceWordAt(value, cursorPosition, convertToMergeField(highlightedItem.title));
    onUpdateValue(id, newValue);
  }
  onUpdateFilter(id, '');
  onClearHighlight(id);
  isPaginated && onResetPaging(id);
};
exports.convertFirstToMergeField = convertFirstToMergeField;
var hasActualSelectionType = function hasActualSelectionType(_ref24) {
  var isSomethingSelected = _ref24.isSomethingSelected,
    isPromotionSelected = _ref24.isPromotionSelected,
    isLookupSelected = _ref24.isLookupSelected;
  return isSomethingSelected && !isPromotionSelected && !isLookupSelected;
};
exports.hasActualSelectionType = hasActualSelectionType;
var hasPossibleSelectionType = function hasPossibleSelectionType(_ref25) {
  var isSomethingSelected = _ref25.isSomethingSelected,
    isPromotionSelected = _ref25.isPromotionSelected,
    isLookupSelected = _ref25.isLookupSelected,
    types = _ref25.types;
  return types.length === 1 && types[0] !== stringType && (!isSomethingSelected || isPromotionSelected || isLookupSelected);
};
exports.hasPossibleSelectionType = hasPossibleSelectionType;